var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-filter"},[(_vm.$mq === 'mobile')?_c('header-mobile-page',{attrs:{"label":_vm.child.name}}):_vm._e(),_c('content-filter-header',{staticClass:"header"}),_c('content-filter',{attrs:{"modeId":_vm.child.default_mode_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }